import { pure } from 'recompose';
import ImageLayerWrapper from './ImageLayerWrapper';

export default pure(ImageLayerWrapper);



// WEBPACK FOOTER //
// ./src/components/ImageLayerWrapper/index.js